import { appGetFullStateObject } from 'legacy/lut/store'
import React, { useEffect, useState } from 'react'

import { ExpressionParser } from 'core/sitebuilder/layout/content/helpers/ExpressionParser'
import { getGlobalsForIframe } from 'core/sitebuilder/layout/content/helpers/getGlobalsForIframe'
import settings from 'src/config/settings'

interface IProps {
  PartnerID: string
}
export const AmplifyDashboard = (props: IProps) => {
  const [iframeUrl, setIframeUrl] = useState('')

  useEffect(() => {
    const src = `${settings.dataServerUrl}/form/688/45d79d0d-dd7d-459f-acac-aff95bd85eb3?p_ott=[global.oneTimeToken]&p_lang=[state.app.user.locale]&p_pid=[pid]`
    getGlobalsForIframe(src).then((globalParams: any) => {
      const newUrl = ExpressionParser(
        src,
        {
          pid: props.PartnerID,
          state: appGetFullStateObject(),
          global: globalParams,
        },
        false
      )

      setIframeUrl(newUrl)
    })
  }, [])

  return (
    <iframe
      src={iframeUrl}
      title={'amplify-check-engine'}
      style={{ width: '100%', minHeight: '100vh', border: 'none' }}
    />
  )
}
